import { useMutation } from "@apollo/client";
import { REMOVE_ORDER_LINE } from "../order-line.queries";
import {
  RemoveOrderLineMutation,
  RemoveOrderLineMutationVariables,
} from "../../../__generated__/RemoveOrderLineMutation";

export const useRemoveOrderLine = () => {
  return useMutation<RemoveOrderLineMutation, RemoveOrderLineMutationVariables>(
    REMOVE_ORDER_LINE,
    {
      refetchQueries: ["OrderLinesQuery"],
    }
  );
};
